import { createContext } from "react";
import type { AavoDataGridProps } from "src/components/common/dataGrid/AavoDataGrid.tsx";

export interface AavoDataGridContextValue
	extends Pick<
		AavoDataGridProps<object>,
		| "refreshData"
		| "hideRefreshButton"
		| "actionBarComponents"
		| "actionBarMenuComponents"
		| "actionBarMenuButtonRef"
		| "openRow"
		| "disableColumnSelector"
		| "hideActionBar"
	> {
	onlySelectedRow?: object;
}

export const AavoDataGridContext = createContext<AavoDataGridContextValue | undefined>(undefined);
